import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
// import { UserApiService } from '../flexseat/user-api.service';

export interface UserGraph {
  id: string
  deletedDateTime: any
  accountEnabled: boolean
  ageGroup: any
  businessPhones: any[]
  city: string
  createdDateTime: string
  creationType: any
  companyName: string
  country: string
  department: string
  displayName: string
  employeeId: string
  employeeType: string
  jobTitle: string
  mail: string
  mailNickname: string
  mobilePhone: any
}

@Injectable({
  providedIn: 'root'
})
export class GraphApiService {

  // Inject the HttpClient service to make HTTP requests
  private readonly http = inject(HttpClient);
  private readonly apiUrl = 'https://graph.microsoft.com/beta';

  getMe(): Observable<UserGraph> {

    //Just selected fields from graph
    const selectedFields = [
    'id',
    'deletedDateTime',
    'accountEnabled',
    'ageGroup',
    'businessPhones',
    'city',
    'createdDateTime',
    'creationType',
    'companyName',
    'country',
    'department',
    'displayName',
    'employeeId',
    'employeeType',
    'jobTitle',
    'mail',
    'mailNickname',
    'mobilePhone'
    ].join(',');

    return this.http.get<UserGraph>(`${this.apiUrl}/me?$select=${selectedFields}`);
  }

  getProfilePic(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.apiUrl}/me/photo/$value`, { responseType: 'blob' }).subscribe({
        next: (blob) => {
          this.blobToBase64(blob).then(resolve).catch(reject);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  //Transform Blob on base64
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      // Validate if its a image
      if (!blob.type.startsWith('image/')) {
        reject(new Error('File is not a valid image'));
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string;

        // Verify if the conversion was successful
        if (result && result.startsWith('data:')) {
          resolve(result);
        } else {
          reject(new Error('Conversion resulted in invalid data'));
        }
      };

      reader.onerror = () => {
        reject(new Error('Error reading blob file'));
      };

      reader.readAsDataURL(blob);
    });
  }

}
